import { enabledForValues, errorTypes } from '../constants'

export const getSelectedValues = ({ enabledForRefunds, enabledForExchanges, enabledForMixed }) => {
  const value = []

  if (enabledForRefunds) value.push(enabledForValues.refunds)
  if (enabledForExchanges) value.push(enabledForValues.exchanges)
  if (enabledForMixed) value.push(enabledForValues.mixed)

  return value
}

export const getEnabledForPayload = selected => {
  return {
    enabled_for_refunds: selected.includes(enabledForValues.refunds),
    enabled_for_exchanges: selected.includes(enabledForValues.exchanges),
    enabled_for_mixed: selected.includes(enabledForValues.mixed),
  }
}

export const getToggledEnabledForValues = ({ value, checked, selectedValues }) => {
  if (checked) return [...selectedValues, value]

  return selectedValues.filter(selected => selected !== value)
}

export const getRegionErrorType = errors => {
  if (errors?.find(error => error.type === errorTypes.invalidRegionForCarrierService)) {
    return errorTypes.invalidRegionForCarrierService
  }

  if (errors?.find(error => error.type === errorTypes.regionsEmpty)) return errorTypes.regionsEmpty

  return null
}

export const getRegionErrorMessage = (errors, selectedRegions, t) => {
  if (errors?.find(error => error.type === errorTypes.invalidRegionForCarrierService)) {
    return t(
      'Algunas regiones no son compatibles con el servicio logístico seleccionado. Seleccione otras regiones o elija otro servicio logístico.'
    )
  }

  if (!selectedRegions?.length) return t('Al menos una región debe estar seleccionada')
}
